module.exports = __webpack_public_path__ + "static/media/roadmapicon.7f426d3c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/roadmapicon.svg
// module id = 1724
// module chunks = 0